import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minutesToHours',
    standalone: false
})
export class MinutesToHoursPipe implements PipeTransform {
    transform(minutes: number): string {
        if (isNaN(minutes) || minutes < 0) {
            return '';
        }

        if (minutes < 60) {
            return `${minutes} minutes`;
        }
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        if (remainingMinutes === 0) {
            return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
        }
        return `${hours} ${hours === 1 ? 'hour' : 'hours'} ${remainingMinutes} minutes`;
    }
}